import * as types from './mutation-types';

const mutations = {
  [types.GET_EXTERNAL_SEGMENTS](state, segments) {
    state.externalSegments = segments;
  },
  [types.GET_EXTERNAL_COUNTRIES_AND_CATEGORIES](state, data) {
    const { categories, locations } = data;
    state.externalCountries = categories;
    state.externalLocations = locations;
  },
};

export default mutations;
